// removed by extract-text-webpack-plugin
module.exports = {"tbody":"tbody-8uZ0p","empty":"empty-2qcmA"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/table/table-body/table-body.less
 ** module id = 188
 ** module chunks = 0
 **/